import { useAppData } from '@app/core/app-data';
import { useStationsStationsUpdate } from '@mi-front/api-v2';

/**
 * Mutation hook to update a station via api-v2 generated mutation (`PUT /stations/v1/:station`).
 * On success, invalidates the stations query so the list refetches and stays in sync.
 *
 * Variables shape matches the generated client: `{ station, data }`.
 */
export function useStationUpdateMutation() {
  const { refetchStations } = useAppData();

  return useStationsStationsUpdate({
    mutation: {
      onSuccess: () => {
        refetchStations();
      },
    },
  });
}
